import { render, staticRenderFns } from "./TopPlanetComponent.vue?vue&type=template&id=5f5fa107&scoped=true&"
import script from "./TopPlanetComponent.vue?vue&type=script&lang=js&"
export * from "./TopPlanetComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopPlanetComponent.vue?vue&type=style&index=0&id=5f5fa107&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5fa107",
  null
  
)

export default component.exports